import React, { Component } from 'react'
import { Modal, Input, Form, Alert, Button } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withApollo } from '@apollo/client/react/hoc'
import * as Utils from '../../../components/Utils'
import _ from 'lodash'
import { withBreakpoint } from '../../../components/Utils'

class SubmitModal extends Component {
	formRef = React.createRef()

	state = {
		loading: false,
		email: null,
		name: null,
		comment: null
	}

	componentDidMount() {
		this.setState({ text: this.props.initialValue })
		// if there is no missing feedback, focus the email field
		const missingFeedback = this.getTrackWithMissingFeedback()
		if (_.isEmpty(missingFeedback)) {
			setTimeout(() => {
				if (this.field) {
					this.field.focus()
				}
			}, 200)
		}
	}

	getTrackWithMissingFeedback = () => {
		const { sample, feedback } = this.props
		const tracksWithoutFeedback = []

		for (const track of sample.trackObjects) {
			const fb = feedback[track?._id]

			if (!fb) {
				tracksWithoutFeedback.push(track)
			} else {
				// dislike
				if (fb.rating === 1) {
					if (!fb.reason || (fb.reason === 'OTHER' && !fb.comment)) {
						tracksWithoutFeedback.push(track)
					}
				}
			}
		}
		return tracksWithoutFeedback.map((t) => `${t.title} (${t.artist})`)
	}

	handleCancel = () => {
		this.props.onClose(false)
	}

	handleOK = async () => {
		const { mutation, client, onClose } = this.props

		let success = true
		try {
			const values = await this.formRef.current.validateFields()
			this.setState({ loading: true })
			const response = await client.mutate(mutation(values))
			Utils.parseMutationResponse(response)
			onClose(success)
		} catch (e) {
			Utils.displayError(e)
		}
		this.setState({ loading: false })
	}

	render() {
		const { intl, screens } = this.props
		const isMobile = !screens.md

		const trackWithMissingFeedback = this.getTrackWithMissingFeedback()

		const first6TracksWithMissingFeedback = trackWithMissingFeedback.slice(
			0,
			6
		)
		const nbRemainingTracksWithMissingFeedback =
			trackWithMissingFeedback.length -
			first6TracksWithMissingFeedback.length

		return (
			<Modal
				maskStyle={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
				visible={true}
				title={intl.formatMessage({ id: 'samples.submit' })}
				onCancel={this.handleCancel}
				footer={[
					<Button
						key="cancel"
						type="dashed"
						onClick={this.handleCancel}
					>
						{intl.formatMessage({ id: 'actions.cancel' })}
					</Button>,
					<Button key="ok" onClick={this.handleOK}>
						{intl.formatMessage({ id: 'actions.submit' })}
					</Button>
				]}
				confirmLoading={this.state.loading}
				width={isMobile ? '90%' : 800}
			>
				{!_.isEmpty(first6TracksWithMissingFeedback) && (
					<Alert
						style={{ textAlign: 'left', margin: 20 }}
						type="warning"
						showIcon
						description={
							<>
								<FormattedMessage
									id="samples.listen.submit.missingFeedback.message"
									values={{
										tracks: trackWithMissingFeedback.join(
											', '
										)
									}}
								/>
								<ul>
									{first6TracksWithMissingFeedback.map(
										(t) => (
											<li key={t}>{t}</li>
										)
									)}
									{nbRemainingTracksWithMissingFeedback >
										0 && (
										<li>
											<FormattedMessage
												id="samples.listen.submit.missingFeedback.remaining"
												values={{
													count: nbRemainingTracksWithMissingFeedback
												}}
											/>
										</li>
									)}
								</ul>
							</>
						}
					/>
				)}

				<p>
					<FormattedMessage id="samples.listen.submitMessage" />
				</p>
				<Form
					ref={this.formRef}
					labelCol={{ span: 10 }}
					wrapperCol={{ span: 14 }}
				>
					<Form.Item
						name="email"
						label={intl.formatMessage({
							id: 'teams.details.email'
						})}
						rules={[
							{
								type: 'email',
								message: intl.formatMessage({
									id: 'teams.addUser.emailInvalid'
								})
							},
							{
								required: true,
								message: intl.formatMessage({
									id: 'teams.addUser.emailEmpty'
								})
							}
						]}
					>
						<Input
							ref={(i) => (this.field = i)}
							autoCapitalize="none"
							autoCompleteType="email"
							autoCorrect="false"
							keyboardType="email-address"
						/>
					</Form.Item>
					<Form.Item
						name="name"
						label={intl.formatMessage({ id: 'name' })}
						rules={[
							{
								required: true,
								message: intl.formatMessage({
									id: 'teams.addUser.nameEmpty'
								})
							}
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="comment"
						label={intl.formatMessage({
							id: 'samples.listen.feedback'
						})}
					>
						<Input.TextArea rows={5} />
					</Form.Item>
				</Form>
			</Modal>
		)
	}
}

export default withBreakpoint(withApollo(injectIntl(SubmitModal)))
